var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authentication"},[( _vm.type == 2 )?_c('advanced-certification'):_vm._e(),(!_vm.type)?_c('index-page'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }